import notify from "devextreme/ui/notify";
import sum from "hash-sum";
import compose from "lodash/fp/compose";
import map from "lodash/fp/map";
// import omit from 'lodash/fp/omit';
/* --------------------------------- imports -------------------------------- */
import {
  ApiCtx,
  createApi,
  delay,
  errorHandler,
  leading,
  put,
  requestMonitor,
  select,
} from "saga-query";

import eventEmitter from "@app/contexts/emitter";
// import { insiderService } from '@app/service/service';
// the same names are definded in uJKarmaTransferApi.pas. Change both or none//
import {
  CONST_LIST_OF_CONTACTS,
  CONST_LIST_OF_MATTERS,
  CONST_LIST_OF_MYWORK,
  CONST_LIST_OF_PERSONS,
  CONST_LIST_SS_OF_AVO,
  CONST_LIST_SS_OF_CTRDOSARE,
  CONST_LIST_SS_OF_INVOICE,
  CONST_LIST_SS_OF_PROFORMA,
} from "@app/state/insider/constants";
import { selectCurrentLoginContext } from "@app/state/insider/login";
import { select_apiProf_usersRaw } from "@app/state/insider/profilesApi";
import {
  IDBListofContacts,
  IListofContacts,
  IProfileResponse,
  TLoaTransferProgress,
} from "@app/types/insider";

// import { progressFetcher } from '../middlewares';
import { inApi } from "../apis/api";
import { isErr } from "../helpers";

export const LIST_OF_CONTACTS = CONST_LIST_OF_CONTACTS; // 'listOf_contacts' as const;
export const LIST_OF_MATTERS = CONST_LIST_OF_MATTERS; //'listOf_matters' as const;
export const LIST_OF_MYWORK = CONST_LIST_OF_MYWORK; // 'listOf_mywork' as const;
export const LIST_OF_PERSONS = CONST_LIST_OF_PERSONS; // 'listOf_persons' as const;
export const LIST_OF_AVOCATI = CONST_LIST_SS_OF_AVO; // 'ss_listOf_avocati' as const;
export const LIST_OF_CTRDOSARE = CONST_LIST_SS_OF_CTRDOSARE; // 'ss_listOf_ctrdosare' as const;
export const LIST_OF_PROFORMA = CONST_LIST_SS_OF_PROFORMA; // 'ss_listOf_proforma' as const;
export const LIST_OF_INVOICE = CONST_LIST_SS_OF_INVOICE; // 'ss_listOf_invoice' as const;
import type { IDBListOfPersons, IListOfPersons } from "@app/types/insider";
import type { TIFCollectionItem } from "@app/types/insider";
import type { Next } from "saga-query";
/* -------------------------------------------------------------------------- */
/*                                 SELECT API                                 */
/* -------------------------------------------------------------------------- */
type TSelectBasePayload = {
  watch?: boolean;
  cancel?: boolean;
};
function endLoaderSession(id: any) {
  eventEmitter.emit("PING_TRANSFER_LOADER", {
    key: id,
    expectedRecords: 1000,
    fetchedRecords: 1000,
  } as TLoaTransferProgress);
}
// the api
// export const api = createApi();
// api.use(requestMonitor());
// api.use(api.routes());
// api.use(errorHandler);
// api.use(progressFetcher(service));

export const getContactsOnSelectApi = inApi.get<TSelectBasePayload>(
  `/select/ss_${LIST_OF_CONTACTS}`,
  function* (ctx: ApiCtx<TSelectBasePayload, any, any>, next) {
    const thisName = LIST_OF_CONTACTS;
    const thisSeed = yield* select(selectCurrentLoginContext);
    ctx.key = `${thisSeed}/${thisName}`;

    /* just copy paste this for a new grid */
    eventEmitter.emit("SHOW_TRANSFER_LOADER");
    yield* delay(64);
    // ctx.loader.id = thisName;
    ctx.cache = true;
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_unsubscribe/${thisName}`,
      });
    }
    yield* put({ type: `ctxKey/${thisName}`, payload: ctx.key });
    yield* next();
    //the data should be in cache by now//
    const result = ctx.json;
    const { ok } = result;
    if (!ok) {
      endLoaderSession(thisName);
      notify(
        "Nu s-au putut prelua datele. Va rugam sa reincercati",
        "error",
        1000
      );
      return;
    }
    //post processing of the data: AMAID FOR AVO_UPDATE etc
    const data0 = ctx.json.data;
    const users = yield* select(select_apiProf_usersRaw);
    const data = data0.map((item: IDBListofContacts): IListofContacts => {
      return {
        C_ID: item.C_ID,
        DENUMIRE: item.DENUMIRE,
        LEGAL_FORM: item.LEGAL_FORM,
        ADRESE: `${item.ADRESE_1 || ""}${item.ADRESE_2 || ""}${
          item.ADRESE_3 || ""
        }`,
        TELEFON: item.TELEFON,
        FAX: item.FAX,
        EMAIL: item.EMAIL,
        WEB_SITE: item.WEB_SITE,
        OBSERVATII: item.OBSERVATII,
        CERINTE_SPECIALE: item.CERINTE_SPECIALE,
        DT_INSERTED: item.DT_INSERTED,
        AVO_INSERTED: users?.[item.AVO_INSERTED]?.PRENUME_NUME || "",
        DT_UPDATED: item.DT_UPDATED,
        AVO_UPDATED: users?.[item.AVO_INSERTED]?.PRENUME_NUME || "",
        NR_INREG: item.NR_INREG,
        CIF: item.CIF,
        IBAN: item.IBAN,
        BANCA: item.BANCA,
      };
    });
    ctx.response = new Response();
    ctx.json = {
      ok: true,
      data: data,
    };
    // <end of post processing
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_subscribe/${thisName}`,
        payload: ctx.payload,
      });
    }
    endLoaderSession(thisName);
  }
);

function preparePersons(data: IDBListOfPersons[]): IListOfPersons[] {
  return compose(
    map((item: any) => {
      return {
        PRS_ID: item.PRS_ID,
        C_ID: item.C_ID,
        NUME: item.NUME,
        PRENUME: item.PRENUME,
        ENTITATE_CONTACT: item.ENTITATE_CONTACT,
        DEPARTAMENT: item.DEPARTAMENT,
        LISTA_TELEFON: item.LISTA_TELEFON,
        LISTA_ADRESA: `${item?.LISTA_ADRESA_1 || ""}${
          item?.LISTA_ADRESA_2 || ""
        }${item?.LISTA_ADRESA_3 || ""}`,
        LISTA_CORESPONDENTA: item.LISTA_CORESPONDENTA,
        LISTA_EMAIL: item.LISTA_EMAIL,
        LISTA_CONEXIUNE: item.LISTA_CONEXIUNE,
        ARHIVAT: item.ARHIVAT,
        DT_INSERTED: item.DT_INSERTED,
        AVO_INSERTED: item.AVO_INSERTED,
        DT_UPDATED: item.DT_UPDATED,
        AVO_UPDATED: item.AVO_UPDATED,
      };
    })
  )(data);
}
export const getPersonsOnSelectApi = inApi.get<TSelectBasePayload>(
  `/select/ss_${LIST_OF_PERSONS}`,
  { saga: leading },
  function* (ctx: ApiCtx<any, any>, next) {
    const thisName = LIST_OF_PERSONS;
    const thisSeed = yield* select(selectCurrentLoginContext);
    ctx.key = `${thisSeed}/${thisName}`;

    /* just copy paste this for a new grid */
    eventEmitter.emit("SHOW_TRANSFER_LOADER");
    yield* delay(64);
    // ctx.loader.id = thisName;
    ctx.cache = true;
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_unsubscribe/${thisName}`,
      });
    }
    yield* next();
    const { ok } = ctx.json;
    if (!ok) {
      endLoaderSession(thisName);
      notify(
        "Nu s-au putut prelua datele. Va rugam sa reincercati",
        "error",
        1000
      );
      return;
    }
    const data = ctx.json.data;
    // because some "out of memory" error we have to map here the data
    ctx.response = new Response();
    ctx.json = {
      ok: true,
      data: preparePersons(data),
    };
    yield* put({ type: `ctxKey/${thisName}`, payload: ctx.key });

    if (ctx.payload?.watch) {
      // todo: #55 there is a double call to the server no matter what the watch is
      // yield* put({
      //   type: `/poll_subscribe/${thisName}`,
      //   payload: ctx.payload,
      // });
    }
    endLoaderSession(thisName);
  }
);

export const getMyworkOnSelectApi = inApi.get<TSelectBasePayload>(
  `/select/ss_${LIST_OF_MYWORK}`,
  // '/raport/raport_mywork_home',
  function* (ctx: ApiCtx<any, any>, next) {
    const thisName = LIST_OF_MYWORK;
    const thisSeed = yield* select(selectCurrentLoginContext);
    ctx.key = `${thisSeed}/${thisName}`;

    /* just copy paste this for a new grid */
    eventEmitter.emit("SHOW_TRANSFER_LOADER");
    yield* delay(64); // wait for the loader to be shown
    // ctx.loader.id = thisName;
    ctx.cache = true;
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_unsubscribe/${thisName}`,
      });
    }
    yield* next();
    const { ok } = ctx.json;
    if (!ok) {
      endLoaderSession(thisName);
      notify(
        "Nu s-au putut prelua datele. Va rugam sa reincercati",
        "error",
        1000
      );
      return;
    }
    yield* put({ type: `ctxKey/${thisName}`, payload: ctx.key });
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_subscribe/${thisName}`,
        payload: ctx.payload,
      });
    }
  }
);

//https://github.com/SoftwizCreation/JurnalKarma/discussions/6#discussion-4674157
export const getAvocatiOnSelectApi = inApi.get<TSelectBasePayload>(
  `/select/${LIST_OF_AVOCATI}`,
  function* (ctx: ApiCtx<any, any>, next) {
    const thisName = LIST_OF_AVOCATI;
    const thisSeed = yield* select(selectCurrentLoginContext);
    ctx.key = `${thisSeed}/${thisName}`;

    /* just copy paste this for a new grid */
    eventEmitter.emit("SHOW_TRANSFER_LOADER");
    yield* delay(64); // wait for the loader to be shown
    // ctx.loader.id = thisName;
    ctx.cache = true;
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_unsubscribe/${thisName}`,
      });
    }
    yield* next();
    const { ok } = ctx.json;
    if (!ok) {
      endLoaderSession(thisName);
      notify(
        "Nu s-au putut prelua datele. Va rugam sa reincercati",
        "error",
        1000
      );
      return;
    }
    yield* put({ type: `ctxKey/${thisName}`, payload: ctx.key });
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_subscribe/${thisName}`,
        payload: ctx.payload,
      });
    }
    endLoaderSession(thisName);
  }
);

export const getCtrDosareOnSelectApi = inApi.get<TSelectBasePayload>(
  `/select/${LIST_OF_CTRDOSARE}`,
  function* (ctx: ApiCtx<any, any>, next) {
    const thisName = LIST_OF_CTRDOSARE;
    const thisSeed = yield* select(selectCurrentLoginContext);
    ctx.key = `${thisSeed}/${thisName}`;

    /* just copy paste this for a new grid */
    eventEmitter.emit("SHOW_TRANSFER_LOADER");
    yield* delay(64); // wait for the loader to be shown
    // ctx.loader.id = thisName;
    ctx.cache = true;
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_unsubscribe/${thisName}`,
      });
    }
    yield* next();
    const { ok } = ctx.json;
    if (!ok) {
      endLoaderSession(thisName);
      notify(
        "Nu s-au putut prelua datele. Va rugam sa reincercati",
        "error",
        1000
      );
      return;
    }
    yield* put({ type: `ctxKey/${thisName}`, payload: ctx.key });
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_subscribe/${thisName}`,
        payload: ctx.payload,
      });
    }
    endLoaderSession(thisName);
  }
);

export const getProformeOnSelectApi = inApi.get<TSelectBasePayload>(
  `/select/${LIST_OF_PROFORMA}`,
  function* (ctx: ApiCtx<any, any>, next) {
    const thisName = LIST_OF_PROFORMA;
    const thisSeed = yield* select(selectCurrentLoginContext);
    ctx.key = `${thisSeed}/${thisName}`;

    /* just copy paste this for a new grid */
    eventEmitter.emit("SHOW_TRANSFER_LOADER");
    yield* delay(64); // wait for the loader to be shown
    // ctx.loader.id = thisName;
    ctx.cache = true;
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_unsubscribe/${thisName}`,
      });
    }
    yield* next();
    const { ok } = ctx.json;
    if (!ok) {
      endLoaderSession(thisName);
      notify(
        "Nu s-au putut prelua datele. Va rugam sa reincercati",
        "error",
        1000
      );
      return;
    }
    yield* put({ type: `ctxKey/${thisName}`, payload: ctx.key });
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_subscribe/${thisName}`,
        payload: ctx.payload,
      });
    }
    endLoaderSession(thisName);
  }
);

export const getInvoiceOnSelectApi = inApi.get<TSelectBasePayload>(
  `/select/${LIST_OF_INVOICE}`,
  { saga: leading },
  function* (ctx: ApiCtx<any, any>, next) {
    /* 
    note Don't return response data, or you would not be able to read the cacheData
    in invoiceFiscal.ts
    By using the cacheData when we load the fiscal we create the cache for the list also
   ... to do. separarate this stuff. normalize it 
    */
    const thisName = LIST_OF_INVOICE;
    const thisSeed = yield* select(selectCurrentLoginContext);
    const paramhash = sum(ctx.payload);
    ctx.key = `${thisSeed}/${thisName}/${paramhash}`;

    ctx.request = ctx.req({
      method: "GET",
      url: `/select/${LIST_OF_INVOICE}?${new URLSearchParams(ctx.payload)}`,
    });
    /* just copy paste this for a new grid */
    eventEmitter.emit("SHOW_TRANSFER_LOADER");
    yield* delay(64); // wait for the loader to be shown
    // ctx.loader.id = thisName;
    ctx.cache = true;
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_unsubscribe/${thisName}`,
      });
    }
    yield* next();
    const { ok } = ctx.json;
    if (!ok) {
      endLoaderSession(thisName);
      notify(
        "Nu s-au putut prelua datele. Va rugam sa reincercati",
        "error",
        1000
      );
      return;
    }
    yield* put({ type: `ctxKey/${thisName}`, payload: ctx.key });
    if (ctx.payload?.watch) {
      yield* put({
        type: `/poll_subscribe/${thisName}`,
        payload: ctx.payload,
      });
    }
    endLoaderSession(thisName);
  }
);

// export const getFiscalInvoicePayments  = inApi.get(
//   "/insider/collect/fiscal-invoice-payments",
//   { saga: leading },
//   function*(ctx:ApiCtx, next:Next) {
//     ctx.cache = true;
//     const thisName = 'fiscal-invoice-payments';
//     const thisSeed = yield* select(selectCurrentLoginContext);
//     ctx.key = `${thisSeed}/${thisName}`;

//     ctx.request = ctx.req({
//       method:'GET',
//       url:`/collect/ivf-collections`,
//       headers:{
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//         credentials: 'include',
//       },
//     });
//     if (ctx.payload?.watch) {
//       yield* put({
//         type: `/poll_unsubscribe/${thisName}`,
//       });
//     }

//     yield* next();
//     const {data} = ctx.json;
//     yield* put({ type: `ctxKey/${thisName}`, payload: ctx.key });
//     if (ctx.payload?.watch) {
//       yield* put({
//         type: `/poll_subscribe/${thisName}`,
//         payload: ctx.payload,
//       });
//     }
//   })
